import { IUnlockCodeRow } from "./UnlockCodesTable";

export const generateCheckboxHeaderState = (
  selectedIds: Set<string>,
  shownData: IUnlockCodeRow[]
) => {
  let foundInSet = 0;
  shownData.forEach(unlockCodeObj => {
    if (selectedIds.has(unlockCodeObj.id)) {
      foundInSet += 1;
    }
  });
  if (foundInSet === shownData.length) {
    return {
      isChecked: true,
      isIndeterminate: false
    };
  } else if (selectedIds.size > 0) {
    return {
      isChecked: false,
      isIndeterminate: true
    };
  } else {
    return {
      isChecked: false,
      isIndeterminate: false
    };
  }
};

export const downloadBase64Image = (base64String, fileName) => {
  // Create a link element
  const link = document.createElement("a");

  // Set the href to the base64 string
  link.href = base64String;

  // Set the download attribute with the desired file name
  link.download = fileName + ".png";

  // Append to the body, trigger the download, then remove the element
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBase64Excel = (base64String, fileName) => {
  // Decode base64 to binary
  const binary = atob(base64String);

  // Convert binary string to byte array
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  // Create a Blob with Excel MIME type
  const blob = new Blob([bytes], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  // Create a link and trigger download
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName + ".xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
